import { animate, sequence, style, transition, trigger } from '@angular/animations';
import { Component, Input, TemplateRef } from '@angular/core';

@Component({
  selector: 'app-right-panel-container',
  templateUrl: './right-panel-container.component.html',
  styleUrls: ['./right-panel-container.component.scss'],
  animations: [
    trigger('openClose', [
      transition(":enter", [style({transform: 'translateX(264px)'}), animate('0.1s')]),
      transition(":leave", [sequence([style({right: '0px'}), animate('0.1s', style({right: '-264px'}))])]),
    ])
  ]
})
export class RightPanelContainerComponent {
  @Input() isVisible = false;
  @Input() currentTemplate: TemplateRef<any> | null = null;

  constructor() { }

}
